import React from 'react';
import './AppLayout.css';
import Background from './Background';

export const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Background>
    <div className="app-main-container">{children}</div>
  </Background>
);
